export const hexDictionary = {
    '03': '#F6F6F6',
    '04': '#0A0A0A',
    '07': '#c7bc9f',
    '08': '#ff9d5c',
    '10': '#F7F7F7',
    '11': '#262626',
    '13': '#E5E5E5',
    '14': '#45322e',
    '15': '#BFBFBF',
    '16': '#8C8C8C',
    '18': '#293133',
    '21': '#4C4C4C',
    '20': '#FFD700',
    '22': '#323232',
    '23': '#FEF8F4',
    '24': '#D6CAC1',
    '25': '#A19891',
    '28': '#A17B67',
    '27': '#E4D7CD',
    '29': '#363330',
    '36': '#F1D7C3',
    '37': '#A1573E',
    '38': '#A14C2F',
    '40': '#9CB0BC',
    '42': '#708186',
    '45': '#434D50',
    '47': '#A1A095',
    '52': '#B08D57',
    '53': '#6B6B63',
    '54': '#371404',
    '56': '#4A5044',
    '58': '#FAF9F6',
    '61': '#BC663A',
    '62': '#a1b49c',
    '66': '#D3D3D3',
    '67': '#B87333',
    '68': '#BC8A41',
    '72': '#BC8A41',
    '73': '#BC8A41',
    '93': '#F6F6F6',
}

export const composingPendantSubFamilyCodes: Record<string, string[]> = {
    "240": ["0820"],
    "207": ["5664", "5662", "5660"],
    "161": ["0270"],
    "162": ["0920"],
    "184": ["0345", "0361"],
    "203": ["5520", "5525"],
    "214": ["5770", "5772", "5774"],
    "248": ["6160", "6165"],
    "217": ["2350", "2351", "2355"],
    "222": ["5935"],
    "230": ["7450", "7455", "7460", "7470", "7475"],
    "239": ["3235"],
    "253": ["5730"]
}

export const PRODUCT_CATEGORIES = {
    REGULAR: 1,
    SPECIFIC_PLAYER: 2,
    MODULAR: 3,
    LG2: 4,
    VIRTUAL: 5,
    TOOLKIT: 6
}

export const PRODUCT_CATEGORIES_OBJECT = Object.entries(PRODUCT_CATEGORIES).map(([description, id]) => ({
    description,
    id,
}))

export const PRODUCT_SUBCATEGORIES = {
    COMPOSING_PENDANTS: 1
}

export const PRODUCT_SUBCATEGORIES_OBJECT = Object.entries(PRODUCT_SUBCATEGORIES).map(([description, id]) => ({
    description,
    id,
}))

export const CONFIGURATOR_TYPES = {
    COMPOSITOR: 5
}

export const PRODUCT_TYPES = {
    REGULAR: "REGULAR",
    CREATION: "CREATION"
}

export const lightProductTypology = {
    description: {
        en: "Luminaires",
        es: "Luminarias",
        de: "Luminaires",
        fr: "Luminaires",
        it: "Luminaires",
        us: "Luminaires"
    },
    id: 1,
    level1: {
        description: {
            en: "Luminaires",
            es: "Luminarias",
            de: "Luminaires",
            fr: "Luminaires",
            it: "Luminaires",
            us: "Luminaires"
        },
        id: 1
    }
}


export const accessoryProductTypology = {
    description: {
        en: "Accessories",
        es: "Accessories",
        de: "Accessories",
        fr: "Accessories",
        it: "Accessories",
        us: "Accessories"
    },
    id: 2,
    level1: {
        description: {
            en: "Accessories",
            es: "Accessories",
            de: "Accessories",
            fr: "Accessories",
            it: "Accessories",
            us: "Accessories"
        },
        id: 2
    }
}

export const DOCSWEBV2_PROGRESS_CODES = {
    STARTED: 1,
    INTERMEDIATE: 4,
    READY: 8,
    ERROR: 3,
    MAX: 17
}

export const DOCSWEBV2_SUBFAMILIES = [
    234, // Circus
    244, // Bind
]
export const SUBFAMILIES_ID = {
    PLUSMINUS: 225,
    STICKS: 219
}

export const accessoriesSubfamiliesExcludedInDomain = [SUBFAMILIES_ID.PLUSMINUS, SUBFAMILIES_ID.STICKS]

const SUBFAMILIES_CODES = {
    MULTIPLE: 259
}

export const PRODUCT_APPLICATION_IDS = {
    wall_lamps: 17,
    bathroom_lamps: 18,
    hanging_lamps: 19,
    floor_lamps: 20,
    ceiling_lamps: 21,
    outdoor_lamps: 22,
    table_lamps: 23,
    lighting_toolkit: 24,
    wall_hanging_lamps: 25,
    ceiling_hanging_lamps: 26,
    wall_ceiling_lamps: 27,
    floor_wall_lamps: 28
}

export default {
    hexDictionary,
    composingPendantSubFamilyCodes,
    DOCSWEBV2_SUBFAMILIES,
    DOCSWEBV2_PROGRESS_CODES,
    SUBFAMILIES_CODES,
    SUBFAMILIES_ID,
    accessoriesSubfamiliesExcludedInDomain
}